export default {
    next_step: '下一步',
    previous_step: '上一步',
    choose_booth: '选择展位',
    fixed_fee: '缴纳展位费用',
    rent_goods: '选择租赁商品',
    settlement: '清单结算确认',
    payment: '支付所有费用'
  }


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/fee.js